import { act_com } from '@lc/action/cardType/Common';
// import { EquipmentMeta } from '@lc/card/meta/ss/EquipmentMeta';
import { createCardEquipmentVerbose } from '@lc/interface/card/equipment/factory';
import { Equipment } from '@lc/interface/card/equipment/types';
import { GameState } from '@lc/interface/gameState/types';

export const getEquipmentVerbose = (EquipmentMeta: Equipment[]) => [
	createCardEquipmentVerbose(
		// 31
		EquipmentMeta[0],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState), // show hand, but for target player id
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState), // show hand, but for target player id
		(
			playerData: any,
			gameState: GameState // means we need to see "player state", so show active contracts & awards should be replaced with a
		) => act_com.notPlayable(playerData, gameState) // "show state" per player. Num factories, batteries, active contracts and awards, graveyards,
	),
	createCardEquipmentVerbose(
		// 32
		EquipmentMeta[1],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState), // show hand, but for target player id
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState) // show hand, but for target player id
	),
	createCardEquipmentVerbose(
		// 33
		EquipmentMeta[2],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState), // show hand, but for target player id
		(playerData: any, gameState: GameState) =>
			act_com.recyclingPlant(playerData, gameState) // show hand, but for target player id
	),
	createCardEquipmentVerbose(
		// 34
		EquipmentMeta[3],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState), // show hand, but for target player id
		(playerData: any, gameState: GameState) =>
			act_com.recyclingPlant(playerData, gameState) // show hand, but for target player id
	),
	createCardEquipmentVerbose(
		// 35
		EquipmentMeta[4],
		(playerData: any, gameState: GameState) =>
			act_com.drawCards(playerData, gameState, 1),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState), // show hand, but for target player id
		(
			playerData: any,
			gameState: GameState // means we need to see "player state", so show active contracts & awards should be replaced with a
		) => act_com.notPlayable(playerData, gameState) // "show state" per player. Num factories, batteries, active contracts and awards, graveyards,
	),
	createCardEquipmentVerbose(
		// 36
		EquipmentMeta[5],
		(playerData: any, gameState: GameState) =>
			act_com.drawCards(playerData, gameState, 1),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState), // show hand, but for target player id
		(
			playerData: any,
			gameState: GameState // means we need to see "player state", so show active contracts & awards should be replaced with a
		) => act_com.notPlayable(playerData, gameState) // "show state" per player. Num factories, batteries, active contracts and awards, graveyards,
	),
	createCardEquipmentVerbose(
		// 37
		EquipmentMeta[6],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState), // show hand, but for target player id
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState) // show hand, but for target player id
	),
	createCardEquipmentVerbose(
		// 38
		EquipmentMeta[7],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState), // show hand, but for target player id
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState) // show hand, but for target player id
	),
	createCardEquipmentVerbose(
		// 39
		EquipmentMeta[8],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState), // show hand, but for target player id
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState) // show hand, but for target player id
	),
];
